import ReviewServices from '@/services/Review'

export const state = () => ({

})

export const mutations = {}

export const actions = {
  getReviewSuggestions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ReviewServices.getReviewSuggestions({
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getOrderForReview ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ReviewServices.getOrderForReview({
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  createReviewsFromOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ReviewServices.createReviewsFromOrder({
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
